import { ViewModel,View, ObservableArray } from "binder"
import  { CreateWarehouseKeepingPartView } from "./createWarehouseKeepingPart-view"
import { WarehouseKeepingDetailViewModel } from "../warehouseKeepingDetail/warehouseKeepingDetail-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { warehouseLocationMultiSelectorViewModel } from "src/Warehouse/warehouseLocationManipulation/warehouseLocationManipulation-viewModel";

export class CreateWarehouseKeepingPartViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: WarehouseKeepingDetailViewModel, id: string, warehouseId: string) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.warehouseKeepingId = id;
        this.warehouseId = warehouseId;

        this.keepingPartProducts = ObservableArray.create<KeepingPartProduct>();
        this.warehouseLocationSelector = new warehouseLocationMultiSelectorViewModel(this, this.warehouseId);
    }
    closePopup(resultCode?: string) {
        this._typedParent.closePopup(resultCode);
    }
    GetDefaultView(): View <ViewModel> {
        return new CreateWarehouseKeepingPartView();
    }
    public getTypeId(): string {
        return "VM-262FC586-2CA2-4C44-93FD-E66EF013461F"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set fromProductCode(v: string) { this._fromProductCode = v; } public get fromProductCode(): string { return this._fromProductCode;} private _fromProductCode: string;
    public set toProductCode(v: string) { this._toProductCode = v; } public get toProductCode(): string { return this._toProductCode;} private _toProductCode: string;
    public set warehouseLocationSelector(v: warehouseLocationMultiSelectorViewModel) { this._warehouseLocationSelector = v; } public get warehouseLocationSelector(): warehouseLocationMultiSelectorViewModel { return this._warehouseLocationSelector;} private _warehouseLocationSelector: warehouseLocationMultiSelectorViewModel;
    public set searchInAll(v: boolean) { this._searchInAll = v; } public get searchInAll(): boolean { return this._searchInAll;} private _searchInAll: boolean;
    public set keepingPartProducts(v: ObservableArray<KeepingPartProduct>) { this._keepingPartProducts = v; } public get keepingPartProducts(): ObservableArray<KeepingPartProduct> { return this._keepingPartProducts;} private _keepingPartProducts: ObservableArray<KeepingPartProduct>;
    public set selectAll(v: boolean) { 
        this._selectAll = v; 
        if (v)
            this.keepingPartProducts.forEach(x => x.isSelected = true);
        else
            this.keepingPartProducts.forEach(x => x.isSelected = false);
    }
    public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;

    private _typedParent : WarehouseKeepingDetailViewModel;

    async searchProduct(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/ListProductsToKeep',{
                KeepingId:this.warehouseKeepingId,
                FromCode:this.fromProductCode,
                ToCode:this.toProductCode,
                SearchInAll:this.searchInAll,
                Locations:this.warehouseLocationSelector.selectedItems.map(q => q.id),
            });
            this.keepingPartProducts.update(...result.Products.map((q,i)=>{
                let r = new KeepingPartProduct(this);
                r.index = i+1;
                r.productName = q.Name;
                r.productBrand = q.Brand;
                r.productCarModel = q.ProductCarModel;
                r.productCode = q.Code;
                r.productIndex = q.ProductIndex;
                r.productId = q.ProductId;
                r.balance = q.Balance;
                r.accessibleBalance = q.AccessibleBalance;
                r.locations = q.Locations;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async createPart() {
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('دسته کالای جدید ثبت شود؟','ایجاد دسته کالا');
            if(confirmation=='no'){
                return;
            }
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/CreateNewWarehouseKeepingPart',{
                WarehouseKeepingId: this.warehouseKeepingId,
                ProductIds: this.keepingPartProducts.filter(x=> x.isSelected).map(q => q.productId)
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('دسته کالای جدید ثبت شد.','عملیات موفق');
            this.closePopup('done');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
}

export class KeepingPartProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CreateWarehouseKeepingPartViewModel) {
        super(parent);
        this._typedParent = parent;   
    }
    private _typedParent:CreateWarehouseKeepingPartViewModel;

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set locations(v: string) { this._locations = v; } public get locations(): string { return this._locations;} private _locations: string;
    
}